export const IMAGE_GALLERY = "/galerija-slika";
export const ABOUT = "/o-nama";
export const CONTACT = "/kontakt";
export const SIGN_UP = "/uclani-se";
export const HOME = "/";

export default [IMAGE_GALLERY, ABOUT, CONTACT, HOME];
